import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';
import { RequiredValidator } from '../validators/Required';

const properties: PropertiesInterface = {
  customGeneratedId: {
    type: 'UUID',
    friendlyName: 'UniqueAttachmentSectionId',
    validators: [],
  },
  attachments: {
    type: 'JSON',
    friendlyName: 'Attachments',
    isArray: true,
    // "Must have at least one attachment" is enforced by the outer field's
    // Required validator (see addRequiredValidator below) so that fields with
    // Required: false can be submitted without uploading any files. Keeping a
    // hardcoded ArrayMin here would force every Attachment field to be
    // effectively required.
    validators: [
      {
        name: 'ArrayMax',
        value: 25,
      },
    ],
  },
};
/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use AttachmentType from application-types instead.
 */
export class AttachmentType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Attachment';

  friendlyName = 'Attachment';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];

  superUserOnly = false;

  properties = properties;

  get example() {
    return {
      customGeneratedId: '123',
      attachments: [],
    };
  }

  get default(): any {
    return {
      customGeneratedId: '',
      attachments: [],
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  addRequiredValidator(validator: RequiredValidator): any {
    if (validator.config?.value) {
      this._schema = this.schema.test(
        'Required',
        `${this.getDisplayName()} is a required field.`,
        value => Boolean(value?.attachments?.length)
      );
    } else {
      this._schema = this.schema.notRequired();
    }
  }
}
export /**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Attachment from application-types instead.
 */
const definition = new AttachmentType();

Types.addBaseType(definition);
